import { NodeViewWrapper, NodeViewWrapperProps } from '@tiptap/react';
import React, { FC } from 'react';
import cn from 'classnames';
import {
  getExternalRenderer,
  getPresetId,
} from '../../../components/utils/tiptap';
import { DaDeviationThumbAttrs } from '../deviation-thumb';
import { useSize } from '../hooks/useSize';
import { useEditorContainerSize } from '../../../components/Editor/Context';
import { EXTENSION_TYPE_NAME } from '../constants';

import viewerStyles from '../Viewer/Viewer.scss';

const DeviationThumbNodeView: FC<NodeViewWrapperProps> = props => {
  const Renderer = props.editor.extensionStorage['da-ext-renderers'].inline;
  const { editor, extension, node } = props;
  const { options } = extension;
  const attrs: DaDeviationThumbAttrs = node.attrs;
  const containerSize = useEditorContainerSize();
  const deviationMediaService = getExternalRenderer(editor, 'mediaService');

  const { width, height } = useSize(
    deviationMediaService,
    attrs,
    options,
    containerSize ?? Infinity
  );

  const nodeKey = `img-${!attrs.width ? 'default' : 'custom'}`;

  return (
    <NodeViewWrapper
      key={nodeKey}
      data-drag-handle="true"
      className={cn(
        'draggable-atomic',
        viewerStyles['outer-span'],
        viewerStyles[`preset-${getPresetId(editor)}`]
      )}
      as={'span'}
      data-deviation={JSON.stringify(attrs.deviation)}
      data-width={attrs.width}
      data-height={attrs.height}
      data-cropping={attrs.cropping}
      data-link={attrs.link}
      data-aspect={attrs.aspect}
      data-da-type={EXTENSION_TYPE_NAME}
    >
      <div
        style={{
          pointerEvents: 'none',
        }}
      >
        <Renderer
          deviation={attrs.deviation}
          width={width}
          height={height}
          crop={attrs.cropping}
          link={attrs.link}
          inEditor
          extOptions={options}
        />
      </div>
    </NodeViewWrapper>
  );
};
DeviationThumbNodeView.displayName = 'DeviationNodeView';

export default DeviationThumbNodeView;
